import script from "./Leaderboards.vue?vue&type=script&setup=true&lang=js"
export * from "./Leaderboards.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__